import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import docAid from "../../assets/doc-aid.png";

const VerifyOTP = () => {
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(600);
  const [timerCompleted, setTimerCompleted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Get OTP data from localStorage (key "userOTP")
  const otpData = JSON.parse(localStorage.getItem("userOTP"));
  const email = otpData?.email || "";

  // Timer logic
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setTimerCompleted(true);
    }
  }, [timer]);

  // Verify OTP
  const verifyOTP = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!otpData) {
      toast.error("No OTP request found. Please regenerate OTP.");
      setLoading(false);
      navigate("/regenerateOTP");
      return;
    }

    // Check if OTP matches (convert both to string for safety)
    if (String(otpData.otp) === String(otp)) {
      toast.success("OTP Verified Successfully!");

      // Clear OTP data to prevent reuse
      localStorage.removeItem("userOTP");

      setLoading(false);
      // Navigate to registration page with email
      navigate("/registerDoctor", {
        state: { email: email },
      });
    } else {
      toast.error("Invalid OTP. Please try again.");
      setLoading(false);
    }
  };

  // Resend OTP
  const resendOTP = () => {
    if (!email) {
      toast.error("Email not found. Please go back and try again.");
      navigate("/regenerateOTP");
      return;
    }

    const newOTP = Math.floor(1000 + Math.random() * 9000);

    // Update OTP in localStorage
    localStorage.setItem(
      "userOTP",
      JSON.stringify({
        email: email,
        otp: newOTP,
        timestamp: Date.now(),
      })
    );

    toast.success(`New OTP sent to ${email} (Demo: ${newOTP})`);

    // Reset timer
    setTimer(600);
    setTimerCompleted(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-5xl w-full bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col lg:flex-row">
        {/* Image */}
        <div className="lg:w-1/2 flex justify-center items-center p-8">
          <img src={docAid} alt="doctor" className="w-[300px] lg:w-[400px]" />
        </div>

        {/* Form */}
        <div
          className="lg:w-1/2 p-10 flex items-center"
          style={{ backgroundColor: "rgb(237,231,242)" }}
        >
          <form onSubmit={verifyOTP} className="w-full">
            <h1 className="text-3xl font-bold text-center mb-3">
              Verify OTP
            </h1>
            <p className="text-center text-gray-600 mb-8">
              OTP sent to <br />
              <span className="font-semibold">{email || "your email"}</span>
            </p>

            <input
              type="text" // use text to avoid number quirks
              inputMode="numeric"
              pattern="[0-9]*"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} // only digits
              placeholder="Enter OTP"
              className="w-full px-6 py-4 rounded-xl bg-white border border-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400"
            />

            <div className="flex justify-end mt-3">
              {!timerCompleted ? (
                <p className="text-red-500">
                  {String(Math.floor(timer / 60)).padStart(2, "0")}:
                  {String(timer % 60).padStart(2, "0")} Min
                </p>
              ) : (
                <button
                  type="button"
                  onClick={resendOTP}
                  className="text-blue-600 hover:text-blue-800"
                >
                  Resend OTP
                </button>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="mt-6 w-full py-4 rounded-xl text-white font-semibold transition hover:scale-105 disabled:opacity-50"
              style={{ backgroundColor: "rgb(7,160,165)" }}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VerifyOTP;